<template>
    <Card>
        <template v-slot:header>
            <h2 class="border-title">集团内排名</h2>
        </template>
        <div class="card-content rank-chart">
            <div class="total-line">
                <div class="rank-line">
                    <span class="rank-data">
                        第
                        <span class="rank-number">1</span>
                        名
                    </span>
                    <br />
                    <div>(共 1 个实体)</div>
                </div>
            </div>
            <div class="report-content-line" style="margin-top: 0px">
                <div class="content-center">
                    <span class="rank-other">0</span>
                    <br />
                    <h2>集团内平均</h2>
                </div>
                <div class="rank-other-split-line"></div>
                <div class="content-center">
                    <span class="rank-other">0</span>
                    <br />
                    <h2>集团内最大</h2>
                </div>
            </div>
        </div>
    </Card>
</template>
<script>
export default {
    name: "SingleRankData",
    methods: {
        setData(data) {},
    },
};
</script>
<style scoped>
.rank-chart {
    height: 330px;
    width: 100%;
    display: inline-block;
}
.rank-line {
    padding-top: 50px;
    height: 100px;
    text-align: center;
    width: 100%;
}
.rank-data {
    color: #1080f2;
    font-size: 30px;
}
.rank-number {
    font-size: 40px;
    font-weight: bolder;
}
.rank-other {
    font-size: 30px;
}
.rank-other-split-line {
    width: 1px;
    background-color: #e6e6e6;
    height: 80px;
    margin: 0px 20px;
    flex: none;
}
</style>
